import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/index.vue";
import ytRoutes from "./yt.js";
import { getPageTitle } from "@/utils/util.js";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
VueRouter.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "*",
    name: "not_found",
    component: () => import("../views/notFound.vue"),
    meta: {
      unrequireLogin: true, // true 为组件不需要登录
    },
  },
  {
    path: "/",
    name: "Home",
    component: Layout,
    children: [
      ...ytRoutes,
    ],
    redirect: {
      path: "/yt/home",
    },
    meta: {
      title: '加载中...',
      unrequireLogin: true, // true 为组件不需要登录
    },
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// let path = this.$router.path.indexOf("py") > -1;
// if (path) {
//   this.$router.push({ name: "pyIndex" });
// } else {
//   this.$router.push({ name: "fx_index" });
// }
router.beforeEach(async (to, from, next) => {
  document.title = '雁塔教育云' || getPageTitle(to.meta.title);
  // console.log("to", to);
  // console.log("from", from);
  // 判断该路由是否不需要登录权限
  if (to.meta && to.meta.unrequireLogin) {
    next();
    // next({ name: "routePage" });
  } else {
    // 需要登陆
    // 通过vuex state获取当前的token是否存在
    if (window.sessionStorage.getItem("SSOP_TOKEN")) {
      next();
    } else {
      /**
       *  未登陆状态，跳转home
       */
      next({ name: "gx_home" });
    }
  }
});

export default router;
